import { CandidateFilterBoxTextProps } from './CandidateFilterBoxText.component';
import CandidateFilterBoxText from './CandidateFilterBoxText.container';

export type CandidateFilterBoxTextTypes = CandidateFilterBoxTextProps;

export default CandidateFilterBoxText;
